export default "__VITE_ASSET__DSXghkiV__"